import React from 'react';
import { useTranslation } from 'react-i18next';

import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Background from 'components/Layout/Background';

import useStyles from './styles';

export interface Variant {
  title?: string;
  text?: string;
  action?: Function;
  hidden?: boolean;
  disabled?: boolean;
  beta?: boolean;
  selected?: boolean;
}

interface Props {
  inside?: boolean;
  dialog?: boolean;
  title?: string;
  variants: Variant[];
  children?: React.ReactNode;
}

const VariantSelect: React.FC<Props> = ({ title, dialog, inside, variants, children }) => {
  const classes = useStyles({ dialog });
  const { t } = useTranslation();

  if (!variants.length) return null;

  return (
    <>
      <Container maxWidth={dialog ? undefined : 'md'} className={classes.wrapper}>
        <Background inside={!!dialog || inside} padding={0} className={classes.root}>
          {title && (
            <Grid item xs={12}>
              <Typography variant={dialog ? 'body2' : 'h1'} align={dialog ? 'left' : 'center'}>
                {t(title)}
              </Typography>
            </Grid>
          )}
          <Grid container alignItems="stretch">
            {variants.map((variant, i) => {
              return variant.hidden ? null : (
                <Grid item xs={12} sm={variants.filter((v) => !v.hidden).length === 2 ? 6 : 4} key={`variant_${i}`}>
                  <Card className={`${classes.card} ${variant.beta ? classes.new : ''}`} elevation={0}>
                    <Box onClick={() => (variant.action && !variant.disabled ? variant.action() : {})} className="cta">
                      <CardContent className={classes.cardContent}>
                        {variant.title && (
                          <Typography variant="h3" className={variant.disabled ? classes.disabled : undefined}>
                            {t(variant.title)}
                          </Typography>
                        )}
                        {variant.text && (
                          <Typography variant="body2" className={variant.disabled ? classes.disabled : undefined}>
                            {t(variant.text)}
                          </Typography>
                        )}
                      </CardContent>
                      <div>
                        <Button
                          variant="contained"
                          color={variant.selected ? 'default' : 'primary'}
                          disabled={variant.disabled}
                        >
                          {t(variant.selected ? 'variantSelection_chosen' : 'variantSelection_choose')}
                        </Button>
                      </div>
                    </Box>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
          {children && <div className={classes.insert}>{children}</div>}
        </Background>
      </Container>
    </>
  );
};

export default VariantSelect;
